import React from "react";

import { useArrow } from "./hooks";

export const Arrow = () => {
  const { getArrowProps } = useArrow();
  return <img {...getArrowProps()} />;
};
